var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "display-flex" },
    [
      _c("PrismEditor", {
        ref: "prismEditor",
        class: _vm.customClass,
        attrs: {
          name: _vm.name,
          highlight: _vm.highlighter,
          "line-mumbers": false
        },
        model: {
          value: _vm.body,
          callback: function($$v) {
            _vm.body = $$v
          },
          expression: "body"
        }
      }),
      _vm._v(" "),
      _vm.hasMacros
        ? [
            _c("button", {
              directives: [
                {
                  name: "t",
                  rawName: "v-t",
                  value: "TOKEN",
                  expression: "'TOKEN'"
                }
              ],
              ref: _vm.tokenButtonRef,
              staticClass: "btn btn-secondary flex--align-self-start",
              attrs: { id: _vm.tokenButtonRef, type: "button" },
              on: { click: _vm.toggleMacrosPopover }
            }),
            _vm._v(" "),
            _c(
              "popover",
              {
                attrs: {
                  "custom-class": "breakdown-legend__popover",
                  placement: "bottom",
                  trigger: "manual",
                  target: "#" + _vm.tokenButtonRef
                },
                on: {
                  show: function($event) {
                    _vm.tagsPopoverVisible = true
                  },
                  hide: function($event) {
                    _vm.tagsPopoverVisible = false
                  }
                },
                model: {
                  value: _vm.showMacrosPopover,
                  callback: function($$v) {
                    _vm.showMacrosPopover = $$v
                  },
                  expression: "showMacrosPopover"
                }
              },
              [
                _c(
                  "template",
                  { slot: "popover" },
                  [
                    _c("MacroSelectionPopover", {
                      attrs: {
                        "focus-dropdown": _vm.tagsPopoverVisible,
                        "trigger-element": _vm.$refs[_vm.tokenButtonRef],
                        macros: _vm.macros
                      },
                      on: {
                        blur: function($event) {
                          _vm.showMacrosPopover = false
                        },
                        "selected-tag": _vm.onSelectedTag
                      }
                    })
                  ],
                  1
                )
              ],
              2
            )
          ]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }